import { useState } from "react";
import usePackagingCheckApi, { getApiErrorMessage } from "../usePackagingCheckApi";

export const reportFileName = (check) => {
  const name = check?.product?.name || check?.files?.updated?.originalName?.replace(/\.pdf$/i, "") || "בדיקה";
  const date = check?.createdAt ? new Date(check.createdAt).toISOString().slice(0, 10) : "";
  return `דוח בדיקת גרפיקה - ${name}${date ? ` - ${date}` : ""}.xlsx`;
};

/** Downloads the archived Excel report of a check */
const useReportDownload = (check) => {
  const api = usePackagingCheckApi();
  const [state, setState] = useState({ loading: false, error: null });

  const download = async () => {
    setState({ loading: true, error: null });
    try {
      await api.downloadReport(check._id, reportFileName(check));
      setState({ loading: false, error: null });
    } catch (error) {
      setState({ loading: false, error: getApiErrorMessage(error, "הורדת הדוח נכשלה") });
    }
  };

  return { download, ...state };
};

export default useReportDownload;
